<div class="loader-wrapper">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>
